import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserListComponent } from './list/user-list.component';
import { UserViewComponent } from './view/user-view.component';
import { UserEditComponent } from './edit/user-edit.component';
import { UserNewComponent } from './new/user-new.component';
import { UserService } from './shared/user.service';
import { UserComponent } from './user.component';
import { NgModule } from '@angular/core';
import { UserRoutingModule, ROUTABLE_COMPONENTS } from './user.routing';
import { MatButtonModule, MatDatepickerModule, MatInputModule, MatCheckboxModule, MatSlideToggleModule, MatTableModule, MatFormFieldModule, MatPaginatorModule } from '@angular/material';
import { FabButtonGroupModule } from '../../../shared/fabbuttongroup/fabbuttongroup.module';
import { SectionBarModule } from '../../../shared/sectionbar/sectionbar.module';

//ccontrols
import { TitlebarModule } from '../../../shared/titlebar/titlebar.module';
import { HeaderModule } from '../../../shared/header/header.module';
import { LoaderModule } from '../../../shared/loader/loader.module';
import { SnackbarModule } from '../../../shared/snackbar/snackbar.module';
import { FileuploadModule } from '../../../shared/fileupload/fileupload.module';
import { FileuploadService } from 'src/app/shared/fileupload/fileupdate.service';
import { DocumentoModule } from '../documentos/documento.module';
import { GridEmptyModule } from 'src/app/shared/gridempty/gridempty.module';

@NgModule({
    imports: [
        BrowserModule,
        MatTableModule,
        MatDatepickerModule,
        UserRoutingModule,
        MatCheckboxModule, MatButtonModule, MatInputModule, MatPaginatorModule,
        FormsModule, ReactiveFormsModule,
        FabButtonGroupModule,
        SectionBarModule, MatSlideToggleModule,
        TitlebarModule, HeaderModule, LoaderModule, SnackbarModule, MatFormFieldModule,
        FileuploadModule, DocumentoModule,
        GridEmptyModule
    ],
    entryComponents: [],
    exports: [],
    declarations: [
        UserListComponent,
        UserViewComponent,
        UserEditComponent,
        UserNewComponent,
        UserComponent,
        ROUTABLE_COMPONENTS
    ],
    providers: [UserService, FileuploadService],
    bootstrap: []
})
export class UserModule {
}
